import { render, staticRenderFns } from "./CardNotifiedClasses.vue?vue&type=template&id=32f7ae30&"
import script from "./CardNotifiedClasses.vue?vue&type=script&lang=ts&"
export * from "./CardNotifiedClasses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports